export const routes = (prefix = `master-data`) => [
    {
        path: `/${prefix}/accounts/financial-periods`,
        name: `${prefix}.accounts.financial-periods.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.accounts.financial-periods.index`,
                PageDescription: "Accounts master data: Financial Periods",
            },
        },
    },
];